import { CheckIconSvg } from '../../assets/icons/svgComponents'

import * as S from './styles'

const SubscribePrice = () => (
  <S.Wrapper>
    <S.CardsContainer>
      <S.Card>
        <S.CardTitle>Freemium</S.CardTitle>
        <S.CardSubtitle>
          <CheckIconSvg />
          Este é o seu plano atual
        </S.CardSubtitle>
        <S.CardPlanPrice>R$ 0,00</S.CardPlanPrice>
        <S.CardPlanTextsContainer>
          <S.CardPlanTextsTitle>O que está incluido</S.CardPlanTextsTitle>
          <S.CardPlanTexts>
            <CheckIconSvg />
            Até 2Gb de arquivos anexos (+800 arquivos de 2,5Mb)
          </S.CardPlanTexts>
          <S.CardPlanTexts>
            <CheckIconSvg />
            Cadastro ilimitado de pacientes
          </S.CardPlanTexts>
          <S.CardPlanTexts>
            <CheckIconSvg />
            Inclusão de novos serviços ilimitada
          </S.CardPlanTexts>
          <S.CardPlanTexts>
            <CheckIconSvg />
            Emissão gratuita de 10 documentos psicológicos mensais
          </S.CardPlanTexts>
          <S.CardPlanTexts>
            <CheckIconSvg />
            Correção ilimitada de documentos psicológicos gerados
          </S.CardPlanTexts>
          <S.CardPlanTexts>
            <CheckIconSvg />
            Edição do texto final dos documentos psicológicos antes da impressão
          </S.CardPlanTexts>
          <S.CardPlanTexts>
            <CheckIconSvg />
            Personalização dos modelos de documentos
          </S.CardPlanTexts>
          <S.CardPlanTexts>
            <CheckIconSvg />
            Personalização de textos de análise dos testes e construtos
          </S.CardPlanTexts>
        </S.CardPlanTextsContainer>
      </S.Card>
      <S.Card>
        <S.CardTitle>Mensal</S.CardTitle>
        <S.CardSubtitle />
        <S.CardPlanPrice>R$ 47,90</S.CardPlanPrice>
        <S.CardPlanTextsContainer>
          <S.CardPlanTextsTitle>
            Todas funcionalidades do fremium mais...
          </S.CardPlanTextsTitle>
          <S.CardPlanTexts>
            <CheckIconSvg />
            Até 20Gb de arquivos anexos (+8.000 arquivos de 2,5Mb)
          </S.CardPlanTexts>
          <S.CardPlanTexts>
            <CheckIconSvg />
            Emissão psicológicos ilimitado
          </S.CardPlanTexts>
        </S.CardPlanTextsContainer>
      </S.Card>
    </S.CardsContainer>
    <S.PlanMessage>
      Parabéns! A sua assinatura freemium foi escolhida e terá{' '}
      <u>todas as funcionalidades ilimitadas até 30/09/2022.</u>
      <br></br>
      <br></br>
      As condições dos planos vigentes são válidas até 31/12/2022. Após este
      prazo, estas condições poderão ser prorrogadas ou alteradas, sem
      necessidade de aviso prévio. Também ao término deste prazo, a oferta de
      qualquer plano poderá ser interrompida assim como poderá ocorrer a criação
      de novos planos.
    </S.PlanMessage>
  </S.Wrapper>
)
export default SubscribePrice
